import { USER_ROLES } from "../interfaces/user";

export enum MAIN_NODES {
    BEEHIVES = "bh",
    USERS = "users",
    BEEHIVES_STATS = "bhstats",
    BEEHIVES_ALERTS = "bhalerts",
    ROLES = "roles",
    AREAS_EXPERTISE = "areas"
}

export enum PERMISSIONS_ACTIONS {
    VIEW = "view",
    EDIT = "edit",
    CREATE = "create",
    DELETE = "delete",
    DOWNLOAD = "download",
    MASSIVE_DOWNLOAD = "massive_download"
}

export enum PERMISSIONS_OPTIONS {
    NO = "null",
    ALL = "all",
    ONLY_OWNED = "only_owned",
    ONLY_AREA = "only_area"
}

export const userRoles = [USER_ROLES.ADMIN, USER_ROLES.USER]

export interface IPermissionsState {
    existBeehivesPermissions: boolean;
    existAlertsPermissions: boolean;
    existStatsPermissions: boolean;
    existUsersPermissions: boolean;
    existAreasPermissions: boolean;
    existRolesPermissions: boolean;
    // beehives
    existViewBeehivesPermission: boolean;
    existCreateBeehivesPermission: boolean;
    existEditBeehivesPermission: boolean;
    existDeleteBeehivesPermission: boolean;
    existDownloadBeehivesPermission: boolean;
    existDownloadAllBeehivesPermission: boolean;
    // beehives alerts
    existViewAlertsPermission: boolean;
    existCreateAlertsPermission: boolean;
    existEditAlertsPermission: boolean;
    existDeleteAlertsPermission: boolean;
    // beehives stats
    existViewStatsPermission: boolean;
    existCreateStatsPermission: boolean;
    existEditStatsPermission: boolean;
    existDeleteStatsPermission: boolean;
    // users
    existViewUsersPermission: boolean;
    existCreateUsersPermission: boolean;
    existEditUsersPermission: boolean;
    existDeleteUsersPermission: boolean;
    // areas
    existViewAreasPermission: boolean;
    existCreateAreasPermission: boolean;
    existEditAreasPermission: boolean;
    existDeleteAreasPermission: boolean;
    // roles
    existViewRolesPermission: boolean;
    existCreateRolesPermission: boolean;
    existEditRolesPermission: boolean;
    existDeleteRolesPermission: boolean;
}